import axios, { AxiosResponse, AxiosErrorResponse, AxiosChatInstance } from '@/libs/axios';
import { useQuery, QueryObserverOptions, MutationOptions, useMutation } from 'react-query';

import { QueryKey } from '@/layouts/shared';
import {
  ConversationQueryResponse,
  CreateChatConversationPayload,
  RemindProductResponse,
  RemindProductType,
} from '@/features/products/detail/const';
import { UserQueryResponse } from '@/features/gifts/send/const';

export const fetchProduct = (id: number | string) => {
  return axios.get(`/api/v1/products/${id}`);
};
export const fetchProductAuth = (id: number | string, token: string) => {  
  return axios.get(`/api/v1/products/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const fetchConversationByProduct = (id: number) => {
  return AxiosChatInstance.get(`/v2/me/chat/conversations/type/product/${id}`);
};

export const createConversation = (payload: CreateChatConversationPayload) => {
  return AxiosChatInstance.post('/v2/me/chat/conversations', payload);
};

export const useCreateChatConversation = (
  options?: MutationOptions<AxiosResponse<any>, AxiosErrorResponse, CreateChatConversationPayload, unknown>
) => {
  return useMutation((payload: CreateChatConversationPayload) => createConversation(payload), options);
};

export const useFetchConversationByProductQuery = (
  id: number,
  options?: QueryObserverOptions<
    AxiosResponse<ConversationQueryResponse>,
    AxiosErrorResponse,
    ConversationQueryResponse,
    AxiosResponse<ConversationQueryResponse>,
    (number | string)[]
  >
) => {
  return useQuery([QueryKey.Conversations, id], () => fetchConversationByProduct(id), options);
};
export const fetchAccountProfile = () => {
  return axios.get('/api/v1/user/profile');
};
export const useFetchUserQuery = (
  options?: QueryObserverOptions<
    AxiosResponse<UserQueryResponse>,
    AxiosErrorResponse,
    UserQueryResponse,
    AxiosResponse<UserQueryResponse>,
    (string | '')[]
  >
) => {
  return useQuery([QueryKey.Users], () => fetchAccountProfile(), options);
};

export const RemindResell = (payload: RemindProductType) => {
  return axios.put('/api/v1/products/remind/resell', payload);
};

export const useRemindResellQuery = (
  options?: MutationOptions<AxiosResponse<RemindProductResponse>, AxiosErrorResponse, RemindProductType, unknown>
) => {
  return useMutation((payload: RemindProductType) => RemindResell(payload), options);
};
